export default __webpack_public_path__ + "static/media/google-play-4.efe23a78.svg";